export const studyIds = [
  {
    title: 'Dermview demo',
    id: '617a803ce2afe300bc72da3a',
  },
]
